import { getFetchWrapper } from "@syf-api-library/core";
import { statementsEnrollmentUrl } from "../endpoints.js";
const queryFnFactory = (config, keyProps) => {
  const fetchWrapper = getFetchWrapper(config);
  return () => {
    const params = new URLSearchParams({
      "cipher.accountId": keyProps.accountId
    });
    if (keyProps.accountIdType) {
      params.set("accountIdType", keyProps.accountIdType);
    }
    return fetchWrapper(`${statementsEnrollmentUrl}?${params}`, {
      method: "GET"
    });
  };
};
export {
  queryFnFactory as default
};
//# sourceMappingURL=query.js.map
